import React from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import { emit } from 'helpers/global-events';
import { InputListBox, InputLabel } from 'containers/form';
import Button, { btnThemes } from 'components/button';
import { iconTypes } from 'components/icon';
import Notification from 'components/notification';
import Row, { Col } from 'components/row';
import LayoutContainer, { Stretch, Fixed } from 'components/layout-container';
import ScrollComponent from 'components/scroll-component';

const classesBemForm = new Bem('modalContentAdmin');

@apiDecorator
export default class MergeModalContent extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    listBoxItems: PropTypes.arrayOf(PropTypes.shape({})),
    onResetSelection: PropTypes.func
  };

  // Action for closing modal window
  static contextTypes = {
    close: PropTypes.func.isRequired
  };

  constructor(...args) {
    super(...args);
    this.onTopicChange = this.onTopicChange.bind(this);
    this.mergeTopics = this.mergeTopics.bind(this);
    this.state = {
      chosenTopic: null
    };
  }

  onTopicChange(chosenTopic) {
    this.setState({ chosenTopic });
  }

  /**
   * Move posts from all topics to one topic in DB.
   *
   * @param topics
   * @param target
   */
  mergeTopics(topics, target) {
    if (target) {
      this.api.post('action/forum/actions-merge-topics/merge', {
        postData: {
          topics,
          target
        }
      })
        .then(() => this.afterMergeTopics(topics))
        .catch(error => reportError(error));

      this.setState({
        chosenTopic: null
      });
    }
  }

  // Call after success merge topics.
  afterMergeTopics(topics) {
    Notification.success('Темы успешно объединены.');

    if (topics.length > 1 && this.context && this.context.close) this.context.close();

    this.props.onResetSelection(false, topics);

    // Update topics.
    emit('updateClubTopics');
  }

  render() {
    const { className, listBoxItems } = this.props;
    const { chosenTopic } = this.state;

    return (
      <ScrollComponent {...classesBemForm({ extra: className })}>
        <div {...classesBemForm('flexColumn')}>
          <LayoutContainer>
            <Stretch>
              <Row>
                <Col allPr={0}>
                  <InputLabel
                    {...classesBemForm('label')}
                    schema={{
                      label: 'Выберите тему в которую переносим сообщения:'
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col allPr={0}>
                  <InputListBox
                    {...classesBemForm('list')}
                    listBoxItems={listBoxItems}
                    value={chosenTopic}
                    dictKey="id"
                    dictValue="title"
                    onChange={this.onTopicChange}
                    nullValueItem={false}

                    // dataBind="entity_id"
                    // value={this.state.selectedHouse}
                    unselectableNonArrayInput
                    // hasLabel
                    // noError
                    radio
                  />
                </Col>
              </Row>
            </Stretch>
            <Fixed {...classesBemForm('footer')}>
              <Row allAuto allJustifyCFlexEnd {...classesBemForm('btnsContainer')}>
                <Col allPr={0} allPl={20}>
                  <Button
                    onClick={() => this.mergeTopics(listBoxItems, chosenTopic)}
                    label="Объединить темы"
                    iconType={iconTypes.copyLink}
                    theme={btnThemes.sky}
                    contentLeft
                    big
                  />
                </Col>
              </Row>
            </Fixed>
          </LayoutContainer>
        </div>
      </ScrollComponent>
    );
  }
}
